import Resource from '@/api/resources/Resource'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'

class DiagnosisSampleService extends Resource {
    async exportToPdf(laboratoryId, sectionLabel, filterModel, sortModel, visibleColumns, selectedIds) {
        let params = {
            page: 0,
            size: 1000,
            sort: sortModel
        }

        return this.axios.put(`/diagnosis/laboratories/${laboratoryId}/reportSamplesGrid`, {
            sectionLabel,
            filterModel,
            columns: visibleColumns,
            entityIdentifiersRequest: { entityIdentifiers: selectedIds }
        }, { params }, {
            responseType: 'arraybuffer',
            type: 'application/pdf'
        }).then(response => response.data)
    }

    async getSamplesForBatchActions(laboratoryId, filterModel, params) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/samples`, filterModel, { params })
        return response.data
    }

    async partiallyUpdateSample(laboratoryId, caseId, sampleId, data) {
        const response = await this.axios.patch(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}`, data)
        return response.data
    }

    async getAllSamplesByLaboratoryAndCaseId(laboratoryId, caseId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples`).then(response => response.data)
    }

    async getSampleById(laboratoryId, caseId, sampleId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}`).then(response => response.data)
    }

    async updateSample(laboratoryId, caseId, sampleId, sample) {
        return this.axios.put(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}`, sample).then(response => response.data)
    }

    async launchAutomatismsAndUpdateSample(laboratoryId, caseId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample) {
        let params = { cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded }
        const response = await this.axios.put(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/launchAutomatismsAndUpdateSample`,
            sample,
            { params })
        return response.data
    }

    async updateSampleFields(laboratoryId, caseId, sampleId, sample) {
        return this.axios.put(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/fields`, sample).then(response => response.data)
    }

    async cancelAutomatismsAndUpdateSample(laboratoryId, caseId, sampleId, sample) {
        return this.axios.put(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/cancelAutomatismsAndUpdateSample`, sample).then(response => response.data)
    }
    async sectionsSummary(laboratoryId, caseId, sampleId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/sectionsSummary`).then(response => response.data)
    }
    async createSampleRevision(laboratoryId, caseId, sampleId, request) {
        const response = await this.axios.post(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/revisions`, request)
        return response.data
    }
}

export default new DiagnosisSampleService()

export const STATUS_OPTIONS_DIAGNOSIS_SAMPLE = [
    SAMPLE_STATES.REGISTERED.code,
    SAMPLE_STATES.IN_PROCESSOR.code,
    SAMPLE_STATES.PROCESSED.code,
    SAMPLE_STATES.ARCHIVED.code,
    SAMPLE_STATES.DISCARDED.code,
    SAMPLE_STATES.REPROCESSING_REQUESTED.code]
